module.exports = __webpack_public_path__ + "empty-document.png?3d83150bc4d22be20d74bbb277e7bac6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty/empty-document.png
// module id = 66
// module chunks = 0